import Toggle from "./Toggle/index";

export default {
  Toggle
};
